import { PromSubcWxMsgV2State } from './index';
// 处理list中的订阅时间subcTime-当订阅状态为已订阅的时候才非空
export const promSubcWxMsgV2SubcTimeTransformer = (res) => {
    const list = (res.list || []).map((item) => {
        if (String(item.subcState) === String(PromSubcWxMsgV2State.HAS_SUBSCRIBE)) {
            return item;
        }
        return Object.assign(Object.assign({}, item), { subcTime: undefined });
    });
    return Object.assign(Object.assign({}, res), { list });
};
